const routes = [{
  path: '/feiche/statistics/category',
  component: () => import('@/views/feiche/statistics/category'),
  name: 'statistics-category',
  meta: {
    title: '险别占比分析'
  }
}, {
  path: '/feiche/statistics/institution',
  component: () => import('@/views/feiche/statistics/institution'),
  name: 'statistics-institution',
  meta: {
    title: '分支机构分析'
  }
}, {
  path: '/feiche/statistics/insurance',
  component: () => import('@/views/feiche/statistics/company'),
  name: 'statistics-insurance',
  meta: {
    title: '保险公司分析'
  }
}, {
  path: '/feiche/statistics/region',
  component: () => import('@/views/feiche/statistics/region'),
  name: 'statistics-region',
  meta: {
    title: '区域占比分析'
  }
}, {
  path: '/feiche/statistics/business',
  component: () => import('@/views/feiche/statistics/business'),
  name: 'statistics-business',
  meta: {
    title: '业务来源分析'
  }
}]

export default routes



// WEBPACK FOOTER //
// ./src/router/feiche/statistics.js